import { jsx } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { MonthCalendar } from "./MonthCalendar.js";
import { useDateSelector } from "../../useDateSelector.js";
const DatesSelector = ({
  monthDate
}) => {
  const monthsData = useDateSelector(monthDate, 1);
  return /* @__PURE__ */ jsx(Stack, { direction: "row", children: /* @__PURE__ */ jsx(Stack, { children: /* @__PURE__ */ jsx(
    Stack,
    {
      direction: "row",
      sx: styles.datesBody,
      className: "dates-selector",
      children: monthsData.map(({ monthDate: monthDate2 }, i) => /* @__PURE__ */ jsx(
        MonthCalendar,
        {
          selectedMonthDate: monthDate2,
          type: "single"
        },
        i
      ))
    }
  ) }) });
}, styles = {
  datesBody: {
    backgroundColor: (t) => t.palette.picker.primary.segment.normal.bg.default
  }
};
export {
  DatesSelector
};
//# sourceMappingURL=DatesSelector.js.map
